import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = {
    key: 1,
    class: "container-sm"
};
const _hoisted_3 = { class: "col-md-12" };
const _hoisted_4 = {
    class: "row category-list",
    style: { "overflow-y": "auto" }
};
const _hoisted_5 = ["category"];
const _hoisted_6 = {
    key: 2,
    class: "container-sm d-flex flex-wrap border-bottom mb-2"
};
const _hoisted_7 = {
    key: 3,
    class: "container-sm border-bottom mb-2 pb-2"
};
const _hoisted_8 = { class: "container-sm" };
const _hoisted_9 = { class: "col-md-12" };
const _hoisted_10 = {
    class: "row g-2 align-items-stretch product-list",
    style: { "overflow-y": "auto" }
};
const _hoisted_11 = ["product"];
const _hoisted_12 = {
    key: 4,
    class: "container-sm border-top mt-2 pt-2 pb-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_category_textblock = _resolveComponent("g-category-textblock");
    const _component_g_category_card = _resolveComponent("g-category-card");
    const _component_g_filter_bar = _resolveComponent("g-filter-bar");
    const _component_g_pager = _resolveComponent("g-pager");
    const _component_g_product_card = _resolveComponent("g-product-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
            : _createCommentVNode("", true),
        _createVNode(_component_g_category_textblock, {
            texte: _ctx.category?.texte?.top
        }, null, 8, ["texte"]),
        ((_ctx.category?.products?.length ?? 0) === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.categories, (category, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: category.id,
                                category: category,
                                class: "col-md-6 col-xl-4"
                            }, [
                                _createVNode(_component_g_category_card, { category: category }, null, 8, ["category"])
                            ], 8, _hoisted_5));
                        }), 128))
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.hasFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_g_filter_bar, { filters: _ctx.filter }, null, 8, ["filters"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$host.options.get('ecommerce_products_filterbar_hidden', this.category.options)), 1)
            ]))
            : _createCommentVNode("", true),
        (_ctx.recordCount > _ctx.pageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_g_pager, {
                    page: parseInt(_ctx.$route?.query?.p ?? 1),
                    records: _ctx.recordCount,
                    "page-size": _ctx.pageSize
                }, null, 8, ["page", "records", "page-size"])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.products, (product, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: product.itemNumber,
                            product: product,
                            class: "col-md-6 col-xl-4 d-flex align-items-stretch"
                        }, [
                            _createVNode(_component_g_product_card, {
                                product: product,
                                options: _ctx.category.options
                            }, null, 8, ["product", "options"])
                        ], 8, _hoisted_11));
                    }), 128))
                ])
            ])
        ]),
        _createVNode(_component_g_category_textblock, {
            texte: _ctx.category?.texte?.bottom,
            location: "bottom"
        }, null, 8, ["texte"]),
        (_ctx.recordCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_g_pager, {
                    page: parseInt(_ctx.$route?.query?.p ?? 1),
                    records: _ctx.recordCount,
                    "page-size": _ctx.pageSize
                }, null, 8, ["page", "records", "page-size"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
